module.exports = function() {
  return new Worker(__webpack_public_path__ + "6890d88d939ff3fdb953.worker.js");
};